import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Icon from "../UI/Icon/Icon";

const PanelContainer = styled.div`
  background-color: #fff;

  padding: 20px;

  border-radius: 3px;
  border: 1px solid rgba(23, 15, 48, 0.25);
  border-top: 0px;
  margin-top: 5px;
  min-height: calc(60vh + 100px);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const IconWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  cursor: pointer;
  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
`;
const Description = styled.p`
  /* color: #666; */
  font-size: 1rem;
  line-height: 1.4;
`;

const Heading = styled.h2`
  color: #333;
  font-size: 1.5em;
`;

class OverviewPanel extends Component {
  render() {
    // remained commented as if we want to replace overview and summary again, incase overview is not present
    // const description = this.props.meetingNotes.error
    //   ? "Meeting's overview is not yet available, Please try again in few minutes. "
    //   : this.props.description
    //     ? this.props.description
    //     : this.props?.meetingNotes.summary?.replace(/^Detailed Summary\s*/, "");
    const description = this.props.meetingNotes.error
      ? "Meeting's overview is not yet available, Please try again in few minutes. "
      : this.props.description
        ? this.props.description
        : "Please see the summary section. No overview available.";
    return (
      <PanelContainer>
        <Header>
          <Heading>Overview</Heading>
          <IconWrapper
            onClick={() => {
              navigator.clipboard.writeText(description);
            }}
          >
            <Icon
              style={{ width: "40px", height: "40px", cursor: "pointer" }}
              name="copy_icon"
            ></Icon>
          </IconWrapper>
        </Header>
        <Description>{description.startsWith("Overview\n\n") ? description.slice("Overview\n\n".length) : description}</Description>
      </PanelContainer>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    meetingNotes: state.meetingNotes,
  };
};
// Connect the component to the Redux store
export default connect(mapStateToProps)(OverviewPanel);
